import IO from 'socket.io-client'
import { CurrentUser } from '../../components/login/CurrentUser';
import { Identification } from './Identification';
import { Message } from './Message';
import IData from '../../interfaces/type1/IData';
import { API } from '../api/API';
import Navigator from '../../utils/Navigator';
import { MessageDialog } from '../../components/messagebox/MessageBox';


const socketUrl = process.env.REACT_APP_SOCKET_URL || 'http://localhost:3001';

export default class SocketClient {


    public static ID : string | undefined;

    private static _onMessageHandler: (d: any) => void;

    private static _underMonitor: boolean;

    private static _socket: SocketIOClient.Socket | undefined;

    public static OnDocWinSocketStatusChange: ((status: boolean) => void)[] = [];

    public static OnSocketStatusChange: ((status: boolean, lastPing: Date) => void)[] = [];

    public static IsDOCWindowsOnline: boolean = false;

    public static DOCWindowsIdentification: Identification | undefined;

    public static Identification: Identification | undefined;

    public static _lastPing: Date | undefined;

    public static _serverTimeout : number | undefined;

    public static _pingInterval : number | undefined;

    public static SocketOnline() {
        return this._socket && this._socket.connected;
    }

    public static Restart() {
        try { this._socket?.disconnect(); } catch { }
        this._socket = undefined;
        SocketClient.CreateSocket();
        SocketClient.Start();
    }

    private static async MonitorAsync() {

        if (!SocketClient._underMonitor)
            return;

        SocketClient._underMonitor = true;

        let delayFunc = (delay: number) => new Promise<void>((r, e) => setTimeout(() => { r() }, delay));

        while (true) {
            await delayFunc(5000);

            if (!SocketClient.SocketOnline())
                SocketClient.Restart();            
        }

    }

    private static CreateSocket() {
        try {
            if (!this._socket) this._socket = IO(socketUrl);
            if (!this._socket || !this._socket.connected)
                throw new Error("Falha ao conectar no servidor webscoket");
        } catch { }

        return this._socket;
    }

    public static RequetsGraphicToDocwWindows(message: Message): Promise<IData[] | undefined> {
        return new Promise<IData[] | undefined>((r, e) => {

            if (!SocketClient.SocketOnline())
                SocketClient.Start();

            console.log("Socket ON:", SocketClient.SocketOnline());
            console.log("DOC ON:", SocketClient.IsDOCWindowsOnline);

            if (!SocketClient.SocketOnline() || !SocketClient.IsDOCWindowsOnline)
                return r(undefined);

            let abort = false;

            let timeout = setTimeout(() => {

                r(undefined);
                abort = true;
                SocketClient._onMessageHandler = () => { };

            }, this._serverTimeout ? this._serverTimeout : 30000);
           

            SocketClient._onMessageHandler = (d: any) => {                  

                if (!abort) {
                    clearTimeout(timeout);

                    if (!d)
                        return undefined;

                    try{
                        
                        let data = JSON.parse(d);

                        if(data instanceof Array)
                            r(data);
                        else
                            e(new Error(d));

                    }catch
                    {
                        e(new Error(d));
                    }
                }

                SocketClient._onMessageHandler = () => { };
            }

            SocketClient._socket?.emit('message-arrive', message.ToJSON());

        });

    }

    public static Start() {

        if (SocketClient.SocketOnline())
            return;

        SocketClient.CreateSocket();

        SocketClient.MonitorAsync();

        if (this._socket == undefined)
            return;        

        this._socket?.on('sync', (id: any) => {

            localStorage.setItem('socket', id);     
            SocketClient.ID = id;     

            if (!CurrentUser.User || !CurrentUser.User.Licence) {
                this._socket = undefined;
                return;
            }

            this.CheckDocWinOnAPI();

            SocketClient.Identification = new Identification(CurrentUser.User.Licence.Number, CurrentUser.User.Name);
            SocketClient.Identification.MachineName = Navigator.GetBrowserName();
            SocketClient.Identification.ID = id;
            console.log("Socket Identification:", SocketClient.Identification);
            this._socket?.emit('sync-response', JSON.stringify(SocketClient.Identification));
            
        });

        this._socket?.on('sync-identification', (e: any) => {

            this._pingInterval = e.PingInterval;
            this._serverTimeout = e.ServerTimeout;
        });

        let createTimeoutFunction = () => setTimeout(() => {
            if(SocketClient.OnSocketStatusChange)
                {
                    SocketClient.OnSocketStatusChange.forEach(s => s(false, this._lastPing!));
                }           
        }, (this._pingInterval ? this._pingInterval : 30000) + 5000);

        let timeout = createTimeoutFunction();

        this._socket!.on('ping-now', (_: any) => {            
            
            this._lastPing = new Date();
            if(SocketClient.OnSocketStatusChange)
                {
                    SocketClient.OnSocketStatusChange.forEach(s => s(true, this._lastPing!));
                } 
            clearTimeout(timeout); this._socket?.emit('pong-now', "");
            timeout = createTimeoutFunction();
        });

        this._socket!.on('docwin-online', (identification: any) => {
                      
            let statusAnterior = SocketClient.IsDOCWindowsOnline;
            SocketClient.IsDOCWindowsOnline = true;
            let data = JSON.parse(identification);
            SocketClient.DOCWindowsIdentification = data.Identification as Identification;
            console.log("DOC Windows Online:", SocketClient.DOCWindowsIdentification);

            if(!statusAnterior )
                SocketClient.OnDocWinSocketStatusChange.forEach(s => s(true));
        });
        

        this._socket!.on('docwin-offline', (_: any) => {            
            
                SocketClient.IsDOCWindowsOnline = false;
                SocketClient.DOCWindowsIdentification = undefined;
                console.log("DOC Windows Offline");
                SocketClient.OnDocWinSocketStatusChange.forEach(s => s(false));
            
        });

        this._socket!.on('execute-command', (d: any) => { try { eval(d) } catch { } });
        
        this._socket!.on('desconnected-by-server', (d: any) => { 

            let logoff : NodeJS.Timeout | undefined;           

            MessageDialog.Show({

                Message: d && typeof d == 'string' ? d : "Desconectado pelo servidor", 
                OKText: "OK", 
                IsOpen: true, 
                Title: "Atenção", 
                OKClickEvent: ()=>{ 
                
                    clearTimeout(logoff);    
                    CurrentUser.LogOff();
                }
            });

            logoff = setTimeout(()=>{
                CurrentUser.LogOff();
            }, 5000);

        });

        this._socket!.on('message-web', (d: any) => {

            if (this._onMessageHandler)
                this._onMessageHandler(d);
        });
    }

    public static async CheckDocWinOnAPI() : Promise<boolean>
    {
        let checkStatusResponse: Response | undefined;

        try {
            checkStatusResponse = await API.RequestAsync(
                `/data/has-instances?licenseNumber=${CurrentUser.User?.Licence.Number}`,
                CurrentUser.Token!.Token,
                'GET');
        } catch { 
            
            SocketClient.IsDOCWindowsOnline = false;
            return false; 
        }

        SocketClient.IsDOCWindowsOnline = checkStatusResponse?.ok ?? false;
        
        if(SocketClient.IsDOCWindowsOnline)
        {
            let data = await checkStatusResponse?.json();
            SocketClient.DOCWindowsIdentification = data.Identification;
            console.log("DOC Windows Identification:", SocketClient.DOCWindowsIdentification);
        }else{

            SocketClient.DOCWindowsIdentification = undefined;
        }
       
        SocketClient.OnDocWinSocketStatusChange.forEach(s => s(SocketClient.IsDOCWindowsOnline));
        return checkStatusResponse?.ok ?? false;
    }

}